// issue 121 / ADR-112 决策 7：Deal Book 投后贡献 60% 的接口（msfund-project /api/v2/project/deal_book/…），类型见 typings/dealBookCycle.ts
import request from '@/utils/request'
import type { CommonRes } from '@/typings'
import type {
  IAllocationGroup,
  IAllocationItem,
  ICycle,
  IPageList,
  IPreListParams,
  IPreRow,
  ISheet,
  ISheetCandidate,
  ISheetCandidateParams,
  ISheetSaveParams,
  IMySubmitBlocker
} from '@/typings/dealBookCycle'

const BASE = '/api/v2/project/deal_book'

// ---- 周期（工作台编辑 / 只读）----
export async function listCycles(params: {
  page?: number
  page_size?: number
  year?: number
  step_type?: number
}) {
  return request<CommonRes<IPageList<ICycle>>>(`${BASE}/cycle/list`, {
    method: 'get',
    data: params
  })
}
export async function getCycle(id: number) {
  return request<CommonRes<{ cycle: ICycle; sheets: ISheet[] }>>(`${BASE}/cycle/get`, {
    method: 'get',
    data: { id }
  })
}
export async function saveCycle(params: {
  id: number
  name: string
  year: number
  remark: string
  hr_uid: number
  finance_uid: number
}) {
  return request<CommonRes<{ id: number }>>(`${BASE}/cycle/save`, { method: 'post', data: params })
}
export async function openCycle(id: number) {
  return request<CommonRes<unknown>>(`${BASE}/cycle/open`, { method: 'post', data: { id } })
}
export async function closeCycle(id: number) {
  return request<CommonRes<unknown>>(`${BASE}/cycle/close`, { method: 'post', data: { id } })
}
export async function hurryCycle(id: number) {
  return request<CommonRes<{ sent: { id: number; name_zh: string; name_en: string }[] }>>(
    `${BASE}/cycle/hurry`,
    { method: 'post', data: { id } }
  )
}

// ---- 模板 / 复核（模板方）----
export async function listSheets(cycleId: number) {
  return request<CommonRes<{ list: ISheet[] }>>(`${BASE}/sheet/list`, {
    method: 'get',
    data: { cycle_id: cycleId }
  })
}
export async function getSheet(id: number) {
  return request<CommonRes<{ sheet: ISheet }>>(`${BASE}/sheet/get`, { method: 'get', data: { id } })
}
export async function saveSheet(params: ISheetSaveParams) {
  return request<CommonRes<{ id: number }>>(`${BASE}/sheet/save`, { method: 'post', data: params })
}
export async function submitSheetReview(id: number) {
  return request<CommonRes<unknown>>(`${BASE}/sheet/submit_review`, {
    method: 'post',
    data: { id }
  })
}
export async function reviewSheet(params: { id: number; pass: boolean; remark?: string }) {
  return request<CommonRes<unknown>>(`${BASE}/sheet/review`, { method: 'post', data: params })
}
// 删除未推送的模板（UAT r3 U3.1）
export async function deleteSheet(id: number) {
  return request<CommonRes<unknown>>(`${BASE}/sheet/delete`, { method: 'post', data: { id } })
}
export async function returnSheet(params: { id: number; remark: string }) {
  return request<CommonRes<unknown>>(`${BASE}/sheet/return`, { method: 'post', data: params })
}
export async function searchPortfolioForSheet(params: ISheetCandidateParams) {
  return request<CommonRes<IPageList<ISheetCandidate>>>(`${BASE}/portfolio/search_for_sheet`, {
    method: 'post',
    data: params
  })
}

// ---- 我的 Deal Book（填写人）----
export async function myList() {
  return request<CommonRes<{ list: ISheet[] }>>(`${BASE}/my/list`, { method: 'get' })
}
export async function myGet(sheetId: number) {
  return request<CommonRes<{ sheet: ISheet }>>(`${BASE}/my/get`, {
    method: 'get',
    data: { sheet_id: sheetId }
  })
}
export async function mySaveItem(params: {
  sheet_id: number
  item_id: number
  allocations: Pick<IAllocationItem, 'target_type' | 'target_uid' | 'points_tenth'>[]
}) {
  return request<CommonRes<unknown>>(`${BASE}/my/save_item`, { method: 'post', data: params })
}
export async function mySubmit(sheetId: number) {
  // blockers 非空 = 未提交（UAT r5 U5.3）
  return request<CommonRes<{ blockers?: IMySubmitBlocker[] }>>(`${BASE}/my/submit`, {
    method: 'post',
    data: { sheet_id: sheetId }
  })
}

// ---- 留档 / 当前分配 ----
export async function listAllocations(params: {
  cycle_id?: number
  portfolio_id?: number
  page?: number
  page_size?: number
}) {
  return request<CommonRes<IPageList<IAllocationGroup>>>(`${BASE}/allocation/list`, {
    method: 'get',
    data: params
  })
}
export async function currentAllocations(portfolioIds: number[]) {
  return request<CommonRes<{ list: IAllocationGroup[] }>>(`${BASE}/allocation/current`, {
    method: 'post',
    data: { portfolio_ids: portfolioIds }
  })
}

// ---- 投前 40% 宽表（投前宽表只读点）----
export async function listPreTable(params: IPreListParams) {
  return request<CommonRes<IPageList<IPreRow>>>(`${BASE}/pre/list`, { method: 'get', data: params })
}
